import React from "react";

// Kit icon-only button. `label` is required: it becomes the aria-label and tooltip.
//   ghost     close, back, more, refresh (hover tint)
//   secondary filled, like the secondary button (platform pickers, standalone icon actions)
//   overlay  on images / media: dark circle, white icon (carousel arrows, image delete)
//   danger   remove / decline (x); removing from an unsaved form needs no confirmation
//   success  accept (check), paired with danger
// Sizes: xs 24px (only on thumbnails / inside inputs), sm 32px, md 40px.
// shape="box": square corners, for a row of equal action buttons (event / account details); set the width.
// Styles: .inyc-icon-btn in src/styles/kit-controls.css.
const VARIANTS = ["ghost", "secondary", "overlay", "danger", "success"];
const SIZES = ["xs", "sm", "md"];
const ICON_PX = { xs: 14, sm: 16, md: 20 };

const IconButton = React.forwardRef(({ icon, label, variant = "ghost", size = "sm", shape = "round", type = "button", className = "", ...rest }, ref) => (
  <button
    ref={ref}
    type={type}
    aria-label={label}
    title={label}
    className={`inyc-icon-btn is-${VARIANTS.includes(variant) ? variant : "ghost"} is-${SIZES.includes(size) ? size : "sm"} ${shape === "box" ? "is-box" : ""} ${className}`.trim()}
    {...rest}
  >
    {React.isValidElement(icon) && icon.props.size == null ? React.cloneElement(icon, { size: ICON_PX[size] || 16 }) : icon}
  </button>
));

export default IconButton;
